import { find, get } from 'lodash';
import { IRequestStudy } from 'modules/Requests/_types';
import { IWebsocketNotification } from './_types';

export const getNotificationArchiveName = (
  notification: Partial<IWebsocketNotification> | null | undefined,
  products: Array<{ code?: string | null; name?: string | null }> = [],
) => {
  const sourceProductCode = get(notification, 'sourceProductCode', '');
  if (sourceProductCode) {
    const product = find(products, ['code', sourceProductCode]);
    return get(product, 'name', sourceProductCode) || sourceProductCode;
  }

  const studies: IRequestStudy[] = get(notification, 'requestId.studyRequestStudies', []);
  for (const study of studies) {
    const archiveName =
      get(study, 'requested.archive.name', '') || get(study, 'provided.archive.name', '');
    if (archiveName) {
      return archiveName;
    }
  }

  return '';
};
